/**
 * Video lazy-load: set <source src> from data-src only when video is in view or user plays.
 * Reduces initial network payload (avoids loading 7MB+ MP4s until needed).
 */
(function () {
  function loadSource(source) {
    var url = source && source.getAttribute('data-src');
    if (url && !source.getAttribute('src')) {
      source.setAttribute('src', url);
      source.removeAttribute('data-src');
    }
  }

  function loadVideo(video) {
    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(loadSource);
  }

  function init() {
    var videos = document.querySelectorAll('video source[data-src]');
    if (!videos.length) return;

    var autoplayVideos = [];
    var otherVideos = [];

    videos.forEach(function (source) {
      var video = source.closest('video');
      if (!video) return;
      if (video.hasAttribute('autoplay') && video.hasAttribute('muted')) {
        if (autoplayVideos.indexOf(video) === -1) autoplayVideos.push(video);
      } else {
        if (otherVideos.indexOf(video) === -1) otherVideos.push(video);
      }
    });

    // Autoplay / background videos: load when in viewport
    if (typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadVideo(entry.target);
            entry.target.load();
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '50px', threshold: 0.01 }
      );
      autoplayVideos.forEach(function (v) {
        io.observe(v);
      });
    } else {
      autoplayVideos.forEach(loadVideo);
    }

    // Non-autoplay (modal, controls): load on first play
    otherVideos.forEach(function (video) {
      function onPlay() {
        if (video.querySelector('source[data-src]')) {
          loadVideo(video);
          video.load();
          video.play();
        }
        video.removeEventListener('play', onPlay);
      }
      video.addEventListener('play', onPlay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
